import { connect } from 'react-redux';

import { DELETE_PLACE_PRICE_TYPES, GET_PLACE_PRICE_TYPES } from 'store/place/actionTypes';

import { CLOSE_MODAL } from 'store/global/modal/actionTypes';

import PriceType from './PriceType';

const mapStateToProps = (state) => ({
  isLoadingGetPlacePriceTypes: state.Place.isLoadingGetPlacePriceTypes,

  placePriceTypes: state.Place.placePriceTypes,
  modalType: state.Modal.modalType,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetPlacePriceTypes: (payload) => dispatch({
    type: GET_PLACE_PRICE_TYPES,
    payload,
  }),

  actionDeletePlacePriceTypes: (payload) => dispatch({
    type: DELETE_PLACE_PRICE_TYPES,
    payload,
  }),

  actionCloseModalCreateRoomSuccess: () => dispatch({
    type: CLOSE_MODAL,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PriceType);
